export type EffectiveStatus = "AVAILABLE" | "UNAVAILABLE";

export interface CountryCapability {
  countryCode: string;
  countryName: string;
  currencyCode?: string;
  currencyCodes?: string[];
  /** @deprecated Use `currencyCode` — kept for older mocks only. */
  currency?: string;
  supportedByCorridors: string[];
  effectiveStatus: EffectiveStatus;
}

export const currencyForCountry = (
  country: CountryCapability | undefined
): string | undefined => currenciesForCountry(country)[0];

export const currenciesForCountry = (
  country: CountryCapability | undefined
): string[] => {
  if (!country) return [];
  const fromList = (country.currencyCodes ?? [])
    .map((c) => c.trim().toUpperCase())
    .filter(Boolean);
  if (fromList.length > 0) return [...new Set(fromList)];
  const single = (country.currencyCode ?? country.currency)
    ?.trim()
    .toUpperCase();
  return single ? [single] : [];
};

export const pickDefaultDestinationCurrency = (
  country: CountryCapability | undefined,
  pinned?: string
): string | undefined => {
  const codes = currenciesForCountry(country);
  if (codes.length === 0) return undefined;
  const wanted = pinned?.trim().toUpperCase();
  if (wanted && codes.includes(wanted)) return wanted;
  return codes[0];
};

export interface DestinationOption {
  countryCode: string;
  countryName: string;
  currencyCode: string;
  supportedByCorridors: string[];
  effectiveStatus: EffectiveStatus;
}

export const expandCountryCurrencyOptions = (
  countries: CountryCapability[]
): DestinationOption[] => {
  const options: DestinationOption[] = [];
  for (const country of countries) {
    for (const currencyCode of currenciesForCountry(country)) {
      options.push({
        countryCode: country.countryCode,
        countryName: country.countryName,
        currencyCode,
        supportedByCorridors: country.supportedByCorridors,
        effectiveStatus: country.effectiveStatus,
      });
    }
  }
  return options;
};
